import { UserRefreshToken } from "../redux/user";
import axios from "axios";

const BaseRoute = "/userapi/api/v1";

export const cfAPI = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  onUploadProgress: function (progressEvent) {
    // Do whatever you want with the native progress event
    // const total = parseFloat(
    //   progressEvent?.currentTarget?.responseHeaders["Content-Length"]
    // );
    // const current = progressEvent.currentTarget.response.length;
    // let percentCompleted = Math.floor((current / total) * 100);
    // console.log("Upload completed: ", percentCompleted);
  },

  // `onDownloadProgress` allows handling of progress events for downloads
  // browser only
  onDownloadProgress: function (progressEvent) {
    // Check for a valid total to avoid division by zero or errors
    if (progressEvent.total > 0) {
      const percentComplete = Math.floor(
        (progressEvent.loaded * 100) / progressEvent.total
      );

      console.log(`Download progress: ${percentComplete}%`);

      // You can dispatch a Redux action or update a state variable here
      // to show the progress in your UI.
    }

    // The download is finished when loaded equals total
    if (progressEvent.loaded === progressEvent.total) {
      console.log("Download completed: 100%");
    }
  },
});

export const Interceptor = (store) => {
  const { dispatch, getState } = store;

  cfAPI.interceptors.request.use(
    (config) => {
      const token = getState()?.users?.userInfo?.token;

      if (token) {
        config.headers["Authorization"] = "Bearer " + token;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  cfAPI.interceptors.response.use(
    (res) => {
      return res;
    },

    async (err) => {
      const originalConfig = err.config;

      if (originalConfig?.url !== `${BaseRoute}/auth/signin` && err.response) {
        if (
          (err.response.status === 401 || err.response.status === 403) &&
          !originalConfig._retry
        ) {
          originalConfig._retry = true;

          const refreshToken = getState()?.users?.userInfo?.refreshtoken;
          try {
            if (refreshToken) {
              const response = await cfAPI.post(
                `${BaseRoute}/auth/refreshToken`,
                {
                  refreshToken: refreshToken,
                }
              );

              dispatch(UserRefreshToken(response.data));
              return cfAPI(originalConfig);
            }
          } catch (_error) {
            return Promise.reject(_error);
          }
        }
      }
    }
  );
};
